import { Component, OnInit } from '@angular/core';
import * as titleActions from './../shared/state/actions/title.action';
import * as fromShared from "./../shared/state/reducers";
import { Store } from '@ngrx/store';
import { AppConfig } from '../core/config/app.config';
import { AppConfigConstants } from '../core/config/app.config.constants';
import { ATSClientTypeConstants } from '../shared/constants/ats-client-type.constants';

@Component({
  templateUrl: './home.component.html',
})

export class HomeComponent implements OnInit {

  constructor(private sharedStore: Store<fromShared.State>) { }

  pageTitle = "Home";

  ngOnInit() {
    this.sharedStore.dispatch(titleActions.SetTitle({ title: this.pageTitle }));

  }

  isForApplicantClient(): boolean {
    return AppConfig.appSetting(AppConfigConstants.ATS_CLIENT_TYPE) === ATSClientTypeConstants.APPLICANT ||
      AppConfig.appSetting(AppConfigConstants.ATS_CLIENT_TYPE) === ATSClientTypeConstants.APPLICANT_AND_USER;
  }

  isForUserClient(): boolean {
    return AppConfig.appSetting(AppConfigConstants.ATS_CLIENT_TYPE) === ATSClientTypeConstants.USER ||
      AppConfig.appSetting(AppConfigConstants.ATS_CLIENT_TYPE) === ATSClientTypeConstants.APPLICANT_AND_USER;
  }
}
